<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects'"
            >Projects</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Update
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <project-form
        formType="update"
        :activeProjectID="activeProjectID"
        @saveProject="updateProject"
      ></project-form>
    </div>
  </div>
</template>
<script>
import ProjectForm from "./forms/projectForm.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
      activeProjectID: null,
    };
  },
  created: function () {
    this.activeProjectID = this.$route.params.projectId;
  },
  components: {
    ProjectForm,
  },
  methods: {
    formValidation(project) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";
      if (project.name.length < 2) {
        missingFieldsString += "Project name is less than 2 characters, ";
        result.isValid = false;
      }
      if (!project.description.length) {
        missingFieldsString += "Project description should not be empty, ";
        result.isValid = false;
      }
      if (!project.start_date) {
        missingFieldsString += "Project start date is not set, ";
        result.isValid = false;
      }
      if (!project.end_date) {
        missingFieldsString += "Project end date is not set, ";
        result.isValid = false;
      }
      if (project.start_date > project.end_date) {
        missingFieldsString += "Project start date should be before end date, ";
        result.isValid = false;
      }
      let maturityList = ["shortterm", "mediumterm", "longterm"];
      if (!maturityList.includes(project.maturity)) {
        missingFieldsString += "Project maturity should be selected, ";
        result.isValid = false;
      }
      if (!project.asset_id) {
        missingFieldsString += "Asset is not selected, ";
        result.isValid = false;
      }
      if (!project.region_id) {
        missingFieldsString += "Region is not selected, ";
        result.isValid = false;
      }
      if (!project.country_id) {
        missingFieldsString += "Country is not selected, ";
        result.isValid = false;
      }
      if (!project.city) {
        missingFieldsString += "City field should not be empty, ";
        result.isValid = false;
      }
      let statusList = ["active", "inactive", "notstarted", "closed"];
      if (!statusList.includes(project.status)) {
        missingFieldsString += "Project status should be selected, ";
        result.isValid = false;
      }
      let acitivityList = ["passive", "semipassive", "active"];
      if (!acitivityList.includes(project.project_activity)) {
        missingFieldsString += "Project activity should be selected, ";
        result.isValid = false;
      }
      if (!project.exit_cause) {
        missingFieldsString += "Project exit cause should not be empty, ";
        result.isValid = false;
      }
      if (!project.method) {
        missingFieldsString += "Project method should not be empty, ";
        result.isValid = false;
      }
      let analysisPeriodList = [
        "monthly",
        "quarterly",
        "biannually",
        "annually",
      ];
      if (!analysisPeriodList.includes(project.exit_analysis)) {
        missingFieldsString += "Project exit analysis should be selected, ";
        result.isValid = false;
      }
      if (!project.financials.principal_native) {
        missingFieldsString += "Project principal should not be empty, ";
        result.isValid = false;
      }
      if (!project.financials.currency_id) {
        missingFieldsString += "Project currency should be selected, ";
        result.isValid = false;
      }
      if (!project.media_id) {
        missingFieldsString += "Project image is not selected, ";
        result.isValid = false;
      }
      if (!project.financials.estimated_roi) {
        missingFieldsString += "Project estimated roi should not be empty, ";
        result.isValid = false;
      }
      let periodList = ["monthly", "quarterly", "biannually", "annually"];
      if (!periodList.includes(project.financials.roi_period)) {
        missingFieldsString += "Project roi period should be selected, ";
        result.isValid = false;
      }
      let levelList = ["low", "medium", "high"];
      if (!levelList.includes(project.rating.risk_level)) {
        missingFieldsString += "Project risk level should be selected, ";
        result.isValid = false;
      }
      if (!levelList.includes(project.rating.risk_reward)) {
        missingFieldsString += "Project risk reward should be selected, ";
        result.isValid = false;
      }
      if (!levelList.includes(project.rating.resilience)) {
        missingFieldsString += "Project resilience should be selected, ";
        result.isValid = false;
      }
      if (!levelList.includes(project.rating.anti_fragility)) {
        missingFieldsString += "Project anti fragility should be selected, ";
        result.isValid = false;
      }
      let partiesList = ["community", "environment", "both", "none"];

      if (!partiesList.includes(project.rating.impacted_parties)) {
        missingFieldsString += "Project impacted parties should be selected, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    updateProject(project) {
      const { isValid, message } = this.formValidation(project);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("updateProject", project);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      projects: (state) => state.projectStore.projectSearch.projects,
      updateProjectStatus: (state) =>
        state.projectStore.projectUpdate.updateProjectStatus,
    }),
  },
  watch: {
    updateProjectStatus() {
      if (this.updateProjectStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Project has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/projects");
        });
      } else if (this.updateProjectStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Project update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/updateProject.vue